<script setup lang="ts">
import { computed } from 'vue'

interface ErrorMessages {
  [field: string]: string
}

export interface Props {
  errors: ErrorMessages | null | undefined
}

const props = defineProps<Props>()

const errorMessages = computed(() => {
  if (!props.errors) return []
  const errors: string[] = []
  for (const [, value] of Object.entries(props.errors)) {
    errors.push(value)
  }
  return errors
})

</script>

<template>
  <div
    v-if="errorMessages?.length"
    class="px-6 pb-6 mt-6"
  >
    <storm-ui-alert
      v-show="errorMessages?.length"
      title="Bitte überprüfe Deine Eingaben:"
    >
      <ul class="list-inside list-disc">
        <li
          v-for="(message, index) in errorMessages"
          :key="index"
        >
          {{ message }}
        </li>
      </ul>
    </storm-ui-alert>
  </div>
</template>
